import { GlobalPostService } from '../../enums/label-providers/globalpost/globalpost-service';
import { UpsWalletService } from '../../enums/label-providers/ups/ups-wallet-service';
import { UspsWalletService } from '../../enums/label-providers/usps/usps-wallet-service';

export const serviceRequirements = {
  [GlobalPostService.StandardIntl]: {
    needsCustoms: true,
    isContinentalUSOnly: false,
    requiresPackageWeight: true,
    isSinglePackageOnly: true,
  },
  [GlobalPostService.Plus]: {
    needsCustoms: true,
    isContinentalUSOnly: false,
    requiresPackageWeight: true,
    isSinglePackageOnly: true,
    maxWeightInPounds: 66,
  },
  [UspsWalletService.GlobalPostStandardIntl]: {
    needsCustoms: true,
    isContinentalUSOnly: false,
    requiresPackageWeight: true,
    isSinglePackageOnly: true,
  },
  [UspsWalletService.GlobalPostPlus]: {
    needsCustoms: true,
    isContinentalUSOnly: false,
    requiresPackageWeight: true,
    isSinglePackageOnly: true,
    maxWeightInPounds: 66,
  },
  [UpsWalletService.Ground]: {
    needsCustoms: false,
    isContinentalUSOnly: true,
    requiresPackageWeight: true,
    isSinglePackageOnly: false,
  },
  [UpsWalletService.GroundSaver]: {
    needsCustoms: false,
    isContinentalUSOnly: true,
    requiresPackageWeight: true,
    isSinglePackageOnly: false,
  },
};
